import styles from "@styles/pages/build-your-own/custom-box.module.scss";
import * as React from "react";
import {createRef, useEffect, useRef, useState} from "react";
import {GiftBoxes} from "../../config/GiftBoxes";
import {useInView} from "framer-motion";
import Button from "@components/button/Button";
import {cssTransition, toast, ToastContainer} from "react-toastify";
import {cleanGraphQLResponse, ShopifyGraphQL} from "@api/Shopify";
import {strapi} from "@api/Strapi";
import qs from "qs";
import AddToCartButton from "@components/add-to-cart-button/AddToCartButton";
import {Provider, useSelector} from "react-redux";
import {sidrStore} from "@redux/store";
import {BuildYourOwnProductDetail} from "@components/build-your-own/product-detail/build-your-own-product-detail";
import {NuritionalInformationHoney} from "../../config/HoneyDataList";

// @ts-ignore
function CustomGiftBox({giftBoxDetail, allProductsDetail, strapiProducts}) {

    /**
     * To rearrange the detail view this action will tell us that the pages is rendered
     * so once rendered we can update the div list.
     */
    const firstRender = useRef(true);
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            reArrangeDetailViews()
            return;
        }
    });

    // Animation of image when scrolling and in view for honey
    const elementsRefHoney = useRef(strapiProducts.map(() => createRef()));
    // @ts-ignore
    const isInViewHoney = elementsRefHoney.current.map((ref: React.RefObject<HTMLDivElement>, _: any) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useInView(ref, {once: false});
    });


    /**
     * Selected honey list
     */
    const [selectedHoneyList, setSelectedHoneyList] = useState<any>([]);

    /**
     * Slide up and down animation for toast
     */
    const slideInOutTransition = cssTransition({
        collapse: false,
        enter: "slide-in-toast",
        exit: "slide-out-toast",
    });


    /***
     * Add to box action for honey
     * @param e
     * @param honey
     * @param isAdd
     * @param index
     */
    const actionHoneyInList = (e: any, honey: any, isAdd = true, index = -1) => {
        if (e) {
            e.stopPropagation();
        }
        if (isAdd) {
            if (selectedHoneyList.length < giftBoxDetail.productLimit) {
                honey.selected = true;
                setSelectedHoneyList([...selectedHoneyList, honey])
            } else {
                toast.info(`You can select maximum ${giftBoxDetail.productLimit} items.`, {
                    toastId: '1',
                    icon: ({theme, type}) => <img src="/assets/images/decorations/extra/ic_toast_message.svg"
                                                  alt={'close'}/>
                })
            }
        } else {
            if (index > -1) {
                honey.selected = false;
                let productList = [...selectedHoneyList];
                productList.splice(index, 1);
                setSelectedHoneyList(productList);
            }
        }
    }


    /***
     * used to store selected product detail view.
     */
        // @ts-ignore
    const [activeDetailElement, setActiveDetailElement] = useState<HTMLElement>(null)

    /***
     * opening detail view for honey product
     * @param e
     * @param index
     */
    const actionClickHoney = (e: any, index: number) => {
        if (e) {
            e.stopPropagation();
        }
        if (activeDetailElement) {
            activeDetailElement.classList.remove('active_detail')
        }
        const htmlElement = document.getElementById('honey-detail-' + index);
        // @ts-ignore
        htmlElement.classList.add('active_detail');
        // @ts-ignore
        setActiveDetailElement(htmlElement);
    }

    const getProductDetail = (productHandle: string) => {
        return allProductsDetail.find((product: any) => product.handle == productHandle)
    }

    /***
     * Arranging details view based on view.
     */
    const reArrangeDetailViews = () => {

        for (let index = 0; index < strapiProducts.length; index++) {

            const itemRef = elementsRefHoney.current[index];
            // @ts-ignore
            const parentWidth = itemRef.current.parentElement.getBoundingClientRect().width;
            // @ts-ignore
            const itemWidth = itemRef.current.getBoundingClientRect().width;
            const perRowColumn = Math.round(parentWidth / itemWidth);
            const row = Math.ceil((index + 1) / perRowColumn);

            const htmlElement = document.getElementById('honey-detail-' + index);
            let insertIndex = (perRowColumn * row);
            if (insertIndex >= elementsRefHoney.current.length) {
                // @ts-ignore
                itemRef.current.parentElement.append(htmlElement)
            } else {
                // @ts-ignore
                itemRef.current.parentElement.insertBefore(htmlElement, elementsRefHoney.current[insertIndex].current)
            }
        }
    }

    const closeDetailView = () => {
        if (activeDetailElement) {
            activeDetailElement.classList.remove('active_detail')
        }
        // @ts-ignore
        setActiveDetailElement(null);

    }

    /**
     * The page contain header and footer component
     * This is custom gift box so based on box type user can select 2 or 3 jars/boxes.
     * also on product click user can see the detail of the product and create a gift-box based on their preference
     */
    return (
        <>
            <div className={styles.banner}>
                <img src={giftBoxDetail.bannerImage} alt={giftBoxDetail.bannerImageAlt}/>
                <div className={'small-text'}>build your own</div>
                <h2>{giftBoxDetail.title}</h2>
                {
                    selectedHoneyList.length == 0 ?
                        <span>do a <br/> great start with <br/>selecting</span> :
                        <>
                            <span>selected products</span>
                            <div className={'product_count'}>
                                <div className={'item'}>
                                    <span>honey packet</span>
                                    <p>{selectedHoneyList.length}</p>
                                </div>
                            </div>
                            <div className={'products'}>
                                <ul>
                                    {
                                        selectedHoneyList.map((item: any, index: number) => {
                                            return (<li key={'honey-' + index} className={'item'}>
                                                <img src={item.attributes.Image.data.attributes.url}
                                                     alt={item.attributes.Image.data.attributes.alternativeText}/>
                                                <div className={'line'}/>
                                                <span>{item.attributes.Title}</span>
                                                <img className={'remove_img'} onClick={(event) => {
                                                    actionHoneyInList(event, item, false, index)
                                                }}
                                                     src={'/assets/images/decorations/extra/ic_close.svg'}
                                                     alt={'remove'}/>
                                            </li>)
                                        })
                                    }
                                </ul>
                            </div>
                            <div className={'clear_add_to_cart'}>
                                <Button classes={'clear_btn'} onClick={() => {
                                    strapiProducts.map((honey: any) => {
                                        honey.selected = false;
                                        return honey
                                    })
                                    setSelectedHoneyList([])
                                }}>clear all</Button>
                                <AddToCartButton classes={''} selectedHoneyList={selectedHoneyList}
                                                 productLimit={giftBoxDetail.productLimit} clearSelection={() => {
                                    strapiProducts.map((honey: any) => {
                                        honey.selected = false;
                                        return honey
                                    })
                                    setSelectedHoneyList([])
                                }}>add to cart</AddToCartButton>
                            </div>
                        </>
                }
            </div>
            <section className={styles.container}>
                <p className={'the_finest_text'} dangerouslySetInnerHTML={{__html: giftBoxDetail.main_title}}></p>
                <p className={'description'} dangerouslySetInnerHTML={{__html: giftBoxDetail.description}}></p>
                <hr/>
                <div className={'product_title'}>
                    <h3>{giftBoxDetail.secondary_title}</h3>
                    <p>{giftBoxDetail.secondary_description}</p>
                </div>
                <hr/>
                <div id="product_list_honey" className={`product_list honey`} onClick={(e) => {
                    // @ts-ignore
                    if (e.target && e.target.id == 'product_list_honey') {
                        closeDetailView()
                    }
                }}>
                    {
                        strapiProducts.map((item: any, index: number) => {
                            // @ts-ignore
                            return (<div key={'product-' + index} ref={elementsRefHoney.current[index]}
                                         className={`item item_honey`} onClick={(e) => {
                                closeDetailView()
                            }}>
                                <img loading={"lazy"}
                                     className={`img_honey ${isInViewHoney[index] ? 'slide-up-animation-active' : 'slide-up-animation'}`}
                                     src={item.attributes.Image.data.attributes.url}
                                     alt={item.attributes.Image.data.attributes.alternativeText} onClick={(e) => {
                                    actionClickHoney(e, index)
                                }}/>
                                <div
                                    className={`bar_line bar_line_honey`} onClick={(e) => {
                                    actionClickHoney(e, index)
                                }}></div>
                                <p onClick={(e) => {
                                    actionClickHoney(e, index)
                                }}>{item.attributes.Title}</p>
                                <div className={`add_to_cart ${item.selected ? 'item_selected' : ''}`}><span/>
                                </div>
                            </div>)
                        })
                    }
                    {
                        strapiProducts.map((item: any, index: number) => {

                            const boxType = giftBoxDetail.type == 'two-jars' ? '' : `-${giftBoxDetail.type}`
                            const product = getProductDetail(item.attributes.Shopify_Link + '-honey-packet-gift-box');
                            item.shopifyProduct = product;
                            return (<Provider key={'honey-detail-' + index} store={sidrStore}><BuildYourOwnProductDetail
                                index={index} key={'honey-detail-' + index}
                                id={'honey-detail-' + index}
                                closeView={closeDetailView}
                                product={product}
                                nuritionalInformation={NuritionalInformationHoney}
                                addToBox={() => {
                                    actionHoneyInList(null, item)
                                    closeDetailView()
                                }}></BuildYourOwnProductDetail> </Provider>)
                        })
                    }
                </div>
                <hr/>
            </section>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                limit={1}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={slideInOutTransition}
                className={styles.toast}
            />
        </>
    )
}

export async function getServerSideProps(context: {
    params: {
        url: any;
    };
    resolvedUrl: string;
}) {
    try {

        let queryObject: any = {
            pagination: {
                page: 1,
                pageSize: 200
            },
            filters: {
                Collection: {
                    Link: {$eq: 'honey-packet'}
                }
            }
        }

        let strapiQuery = qs.stringify(queryObject, {encodeValuesOnly: true,});

        let strapiProducts = [];
        const responseStrapiProducts = await strapi.getProductsList(strapiQuery);
        if (responseStrapiProducts.status == 200 && responseStrapiProducts.data && responseStrapiProducts.data.data) {
            strapiProducts = responseStrapiProducts.data.data;
        }

        const key = context.params.url;
        const giftBoxDetail = GiftBoxes.find(item => item.type === key.toLowerCase());
        if (!giftBoxDetail) {
            return {
                notFound: true,
            }
        }
        const query = `{
                          collectionByHandle(handle: "gift-box") {
                            products(first: 200) {
                              edges {
                                node {
                                  id
                                  tags
                                  title
                                  totalInventory
                                  descriptionHtml
                                  handle
                                  images(first: 50) {
                                    edges {
                                      node {
                                        id
                                        src
                                        altText
                                        originalSrc
                                      }
                                    }
                                  }
                                  variants(first: 10) {
                                    edges {
                                      node {
                                        id
                                        availableForSale
                                        sku
                                        price {
                                          amount
                                        }
                                      }
                                    }
                                  }
                                  metafields(identifiers: [ 
                                                     {namespace: "custom", key: "grade"}, 
                                                     {namespace: "custom", key: "falvor"},
                                                     {namespace: "custom", key: "form"}, 
                                                     {namespace: "custom", key: "ingredients_description"}, 
                                                     {namespace: "custom", key: "net_wet"}, 
                                                     {namespace: "custom", key: "sub_title"},
                                                    ]) {
                                    id
                                    key
                                    value
                                  }                      
                                }
                              }
                            }
                          }
                        }
                        `
        const response = await ShopifyGraphQL.makeRequest(query);
        if (response.status == 200 && response.data && response.data.data && response.data.data.collectionByHandle) {
            let products = cleanGraphQLResponse(response.data.data.collectionByHandle).products;
            products = products.map((product: any) => {
                let editedMetaFields = {};
                if (product.metafields) {
                    product.metafields.map((item: any) => {
                        if (item) {
                            if (item.key == 'ingredients_description') {
                                let arrDescription = item.value.split(',');
                                arrDescription[0] = `<strong>${arrDescription[0]}</strong>`;
                                // @ts-ignore
                                editedMetaFields[item.key] = arrDescription.join(',');
                            } else {
                                // @ts-ignore
                                editedMetaFields[item.key] = item.value;
                            }
                        }
                    })
                }
                product.metafields = editedMetaFields;
                return product
            });

            const seoDetails = {
                // title: `${giftBoxDetail.title} | SIDR®`,
                url: context.resolvedUrl,
                // description: key == 'small-box' ? 'The value of freedom to choose is understood when people make it with care. Build your SIDR® raw honey packets box filled with flavors and varieties you love.' : 'SIDR® raw honey box are visually pleasing to serve. Build your own honey box filled with a palette of different natural flavors you love.',
                // keyword: key == 'small-box' ? 'SIDR raw honey small box' : 'SIDR raw honey large box',
            };

            return {props: {giftBoxDetail, allProductsDetail: products, strapiProducts, seoDetails}}
        }

    } catch (e) {
        console.log(e)
    }
    return {
        notFound: true,
    }
}

export default CustomGiftBox;
